<template>
	<div class="skySelect">
		<el-select
			:style="{ width: width }"
			v-model="selected"
			:placeholder="placeholder"
			:multiple="multiple"
			:multiple-limit="multipleLimit"
			:remote="remote"
			:remote-method="remoteMethod"
			:collapse-tags="collapseTags"
			:filterable="filterable"
			:clearable="clearable"
			:disabled="isFunction(disabled) ? disabled() : disabled"
			:allow-create="allowCreate"
			:default-first-option="defaultFirstOption"
			@change="handleChange"
		>
			<el-option
				v-for="(item, index) in list"
				:key="index"
				:label="item[props.label]"
				:value="item[props.value]"
				:disabled="filterOptions ? item.disabled() : item['status'] == 1"
			>
			</el-option>
		</el-select>
	</div>
</template>
<script>
import googleads from '@/backend/services/googleAds/googleAds.js';
export default {
	name: 'skySelect',
	props: {
		placeholder: {
			type: String,
			default: '请选择',
		},
		value: {
			default: null,
			required: true,
		},
		options: {
			type: Array,
			default: () => [],
		},
		multiple: {
			type: Boolean,
			default: false,
		},
		multipleLimit: {
			type: Number,
			default: 0,
		},
		// 默认下拉框可以输入搜素
		filterable: {
			type: Boolean,
			default: true,
		},
		collapseTags: {
			type: Boolean,
			default: false,
		},
		clearable: {
			type: Boolean,
			default: true,
		},
		disabled: {
			type: [Boolean, Function],
			default: false,
		},
		filterOptions: {
			type: Function,
			default: null,
		},
		dict: {
			type: String,
			default: '',
		},
		code: {
			type: String,
			default: '',
		},
		// 动态code
		dynamicCode: {
			type: String,
			default: '',
		},
		props: {
			type: Object,
			default: () => {
				return {
					label: 'name',
					value: 'code',
				};
			},
		},
		width: {
			type: String,
			default: '100%',
		},
		allowCreate: {
			type: Boolean,
			default: false,
		},
		defaultFirstOption: {
			type: Boolean,
			default: false,
		},
		remote: {
			type: Boolean,
			default: false,
		},
		remoteMethod: {
			default: null,
		},
	},
	watch: {
		dict: {
			handler: function (val) {
				if (val) {
					this.getDict(val);
				}
			},
			immediate: true,
		},
		code: {
			handler: function (val) {
				if (val) {
					this.getCode(val);
				}
			},
			immediate: true,
		},
		value: {
			handler: function (val) {
				this.selected = val;
			},
			immediate: true,
		},
		options: {
			handler: function (val) {
				this.list = this.filterOptions ? this.filterOptions(val) : val;
			},
			immediate: true,
		},
	},
	data() {
		return {
			selected: '',
			list: [],
		};
	},
	methods: {
		handleChange(val) {
			this.$emit('change', val);
			this.$emit('input', val);
		},
		async getCode(code) {
			let res = await googleads.codeFun(code);
			this.list = this.filterOptions ? this.filterOptions(res.data) : res.data;
		},
		async getDict(dict) {
			let res = await googleads.dictFun(dict);
			this.list = this.filterOptions ? this.filterOptions(res.data) : res.data;
		},
		isFunction(val) {
			return Object.prototype.toString.call(val) === '[object Function]';
		},
	},
};
</script>
